import {
  GET_LAYERS,
  GET_LAYERS_ERROR,
  GET_LAYERS_SUCCESS,
  CREATE_LAYER,
  CREATE_LAYER_SUCCESS,
  CREATE_LAYER_ERROR,
  UPDATE_LAYER,
  UPDATE_LAYER_SUCCESS,
  UPDATE_LAYER_ERROR,
  DELETE_LAYER,
  DELETE_LAYER_SUCCESS,
  DELETE_LAYER_ERROR,
  SET_CREATING_LAYER,
  SET_CURRENT_LAYER,
  SET_CURRENT_TRAIT,
  SET_CREATING_TRAIT,
  CREATE_TRAIT_SUCCESS,
  CREATE_TRAIT_ERROR,
  DELETE_TRAIT,
  DELETE_TRAIT_SUCCESS,
  DELETE_TRAIT_ERROR,
  UPDATE_TRAIT,
  UPDATE_TRAIT_SUCCESS,
  UPDATE_TRAIT_ERROR,
  UPDATE_LAYER_LIST,
  UPDATE_LAYER_LIST_SUCCESS,
  UPDATE_LAYER_LIST_ERROR,
  SET_ORDER_LAYER_MODAL,
} from '../contants';

/// Listing Layers
export const setCreatingTrait = (layerId) => ({
  type: SET_CREATING_TRAIT,
  payload:
    layerId === false
      ? layerId
      : { layerId, loading: false, message: { type: false, text: '' } },
});
export const creatingTraitSucceed = (trait) => ({
  type: CREATE_TRAIT_SUCCESS,
  payload: trait,
});

export const creatingTraitFailed = (message) => ({
  type: CREATE_TRAIT_ERROR,
  payload: message,
});

export const getLayers = (collectionId) => ({
  type: GET_LAYERS,
  payload: collectionId,
});
export const getLayersSuccess = (layers) => ({
  type: GET_LAYERS_SUCCESS,
  payload: layers,
});
export const getLayersError = (message) => ({
  type: GET_LAYERS_ERROR,
  payload: message,
});

export const setCurrentLayer = (id) => ({
  type: SET_CURRENT_LAYER,
  payload: id,
});

export const setCurrentTrait = (id) => ({
  type: SET_CURRENT_TRAIT,
  payload: id,
});

/**
 *
 * @param {object|boolean} value
 * @returns {void}
 */
export const setCreatingLayer = (value) => ({
  type: SET_CREATING_LAYER,
  payload: value,
});
export const createLayer = (layer) => {
  return {
    type: CREATE_LAYER,
    payload: layer,
  };
};
export const createLayerSuccess = (layer) => ({
  type: CREATE_LAYER_SUCCESS,
  payload: layer,
});
export const createLayerError = (message) => ({
  type: CREATE_LAYER_ERROR,
  payload: message,
});

/**
 *
 * @param {object|boolean} layer
 * @returns {void} Nothing
 */
export const updateLayer = (layer) => ({
  type: UPDATE_LAYER,
  payload: layer,
});
export const updateLayerSuccess = (layer) => ({
  type: UPDATE_LAYER_SUCCESS,
  payload: layer,
});
export const updateLayerError = (message) => ({
  type: UPDATE_LAYER_ERROR,
  payload: message,
});

// changing layers order
export const updateLayerList = (layers) => ({
  type: UPDATE_LAYER_LIST,
  payload: layers,
});
export const updateLayerListSuccess = (layer) => ({
  type: UPDATE_LAYER_LIST_SUCCESS,
  payload: layer,
});
export const updateLayerListError = (message) => ({
  type: UPDATE_LAYER_LIST_ERROR,
  payload: message,
});
export const setOrderLayerModal = (val) => ({
  type: SET_ORDER_LAYER_MODAL,
  payload: val,
});

/// Deleting Layer
export const deleteLayer = (layer) => ({
  type: DELETE_LAYER,
  payload: layer,
});
export const deleteLayerSuccess = (collection) => ({
  type: DELETE_LAYER_SUCCESS,
  payload: collection,
});
export const deleteLayerError = (message) => ({
  type: DELETE_LAYER_ERROR,
  payload: message,
});

export const deleteTrait = (trait) => {
  console.log('trydel:', trait);
  return {
    type: DELETE_TRAIT,
    payload: trait,
  };
};
export const deleteTraitSuccess = (trait) => ({
  type: DELETE_TRAIT_SUCCESS,
  payload: trait,
});
export const deleteTraitError = (message) => ({
  type: DELETE_TRAIT_ERROR,
  payload: message,
});

export const updateTrait = (trait) => ({
  type: UPDATE_TRAIT,
  payload: trait,
});
export const updateTraitSuccess = (trait) => ({
  type: UPDATE_TRAIT_SUCCESS,
  payload: trait,
});
export const updateTraitError = (message) => ({
  type: UPDATE_TRAIT_ERROR,
  payload: message,
});
